/* Wishlist saved in this browser only (localStorage) - no backend, no app.
 * Every string comes from theme settings via data attributes on the markup. */
(() => {
  const key = 'kp_wishlist_v1';
  const safeProductUrl = (value) => {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin && url.pathname.startsWith('/products/')
        ? `${url.pathname}${url.search}` : null;
    } catch (_) { return null; }
  };
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      const seen = new Set();
      return Array.isArray(value) ? value.filter((item) => {
        if (!item?.id || !safeProductUrl(item.url) || seen.has(String(item.id))) return false;
        seen.add(String(item.id));
        return true;
      }) : [];
    } catch (_) { return []; }
  };
  let items = read();
  const save = () => { try { localStorage.setItem(key, JSON.stringify(items)); } catch (_) { /* private mode: this page view still works */ } };
  const panel = document.querySelector('[data-kp-wishlist-panel]');
  const fill = (template, title) => (template || '[product]').replace('[product]', title);

  const render = () => {
    document.querySelectorAll('[data-kp-wishlist-count]').forEach((el) => { el.textContent = String(items.length); });
    document.querySelectorAll('[data-kp-wishlist-toggle]').forEach((button) => {
      const saved = items.some((item) => item.id === button.dataset.productId);
      const title = button.dataset.productTitle || '';
      const template = saved ? button.dataset.removeAriaTemplate : button.dataset.addAriaTemplate;
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', fill(template, title));
    });
    const list = document.querySelector('[data-kp-wishlist-items]');
    if (!list) return;
    list.replaceChildren();
    if (!items.length) {
      const empty = document.createElement('p');
      empty.className = 'kp-wishlist-empty';
      empty.textContent = panel?.dataset.emptyNote || '';
      list.append(empty);
      return;
    }
    items.forEach((item) => {
      const row = document.createElement('div');
      row.className = 'kp-wishlist-row';
      const image = document.createElement('img');
      if (item.image) { image.src = item.image; image.alt = ''; image.loading = 'lazy'; }
      const link = document.createElement('a');
      link.href = safeProductUrl(item.url);
      link.textContent = item.title || '';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = '×';
      remove.setAttribute('aria-label', fill(panel?.dataset.rowRemoveAriaTemplate, item.title || ''));
      remove.dataset.kpWishlistRemove = item.id;
      if (image.src) row.append(image);
      row.append(link, remove);
      list.append(row);
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-kp-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      const id = toggle.dataset.productId;
      if (items.some((item) => item.id === id)) items = items.filter((item) => item.id !== id);
      else if (safeProductUrl(toggle.dataset.productUrl)) items.push({ id, title: toggle.dataset.productTitle, url: toggle.dataset.productUrl, image: toggle.dataset.productImage });
      save();
      render();
      return;
    }
    const remove = event.target.closest('[data-kp-wishlist-remove]');
    if (remove) { items = items.filter((item) => item.id !== remove.dataset.kpWishlistRemove); save(); render(); return; }
    if (event.target.closest('[data-kp-wishlist-open]')) { if (panel) panel.hidden = !panel.hidden; return; }
    if (event.target.closest('[data-kp-wishlist-close]')) { if (panel) panel.hidden = true; return; }
    if (panel && !panel.hidden && !event.target.closest('[data-kp-wishlist-panel]')) panel.hidden = true;
  }, true);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && panel) panel.hidden = true; });
  document.addEventListener('shopify:section:load', render);
  render();
})();
